module.exports = __webpack_public_path__ + "img/file-attachment-05.f306dbe0.svg";